import {olivioLuminaires as luminaires} from '../luminaires/olivioLuminaires';
import {OlivioLayout} from './olivioLayout';

const conf = {
	...OlivioLayout.conf,

	verticalMinOffset: 0.3,

	floracion: {
		piccolo: {
			verticalMinOffset: 0.45,
		},
		medioGrande: {
			verticalMinOffset: 0.6,
		},
	},
};



class OlivioLinearLayout extends OlivioLayout {
	static conf = conf;

	calculate(design, configValues) {
		let amount = configValues.numberOfHeads;

		const branches = [];

		const {angle, heightMin, heightMax} = this.calculateLimits(design, configValues);

		const housingSize = String(configValues.housingSize).toLowerCase().includes('piccolo') ? 'piccolo' : 'medioGrande';
		const verticalMinOffset = this.getConfValue('verticalMinOffset', [design, housingSize]);

		const verticalRange = heightMax - heightMin;
		const maxNumberOfHeads = Math.floor(verticalRange / verticalMinOffset) + 1;

		amount = Math.min(amount, maxNumberOfHeads);
		const verticalOffset = amount > 1 ? verticalRange / (amount - 1) : 0;

		for (let i = amount-1; i >= 0; i--) {
			const height = Math.round((heightMin + verticalOffset * i) * 1000) / 1000;
			branches.push({
				angle: angle,
				height: height,
			});
		}

		return {
			maxNumberOfHeads: maxNumberOfHeads,
			branches: branches
		};
	}
	calculateLimits(design, configValues) {
		const DesignClass = luminaires[design];
		const entry = DesignClass.poleSizes[DesignClass.getPoleId(configValues)];
		return {
			angle: configValues.angleMax,
			heightMax: Math.min(entry.maxHeight, Math.max(configValues.heightMax, configValues.heightMin)),
			heightMin: Math.min(entry.maxHeight, configValues.heightMax, configValues.heightMin),
		};
	}
}

export {OlivioLinearLayout};
